<template>
    <hts-router-drawer
        :title="$t('labels.approveContract')"
        is-close>
        <hts-card>
            <hts-form-button
                class="w-full"
                @click="downloadContract">
                {{ $t('labels.downloadContract') }}
            </hts-form-button>

            <div
                v-if="buttonApprove"
                class="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-10">
                <hts-form-button
                    class="w-full"
                    color="info"
                    size="small"
                    @click="approveContract('approve')">
                    {{ $t('labels.approve') }}
                </hts-form-button>

                <hts-form-button
                    class="w-full"
                    color="error"
                    size="small"
                    @click="approveContract('refuse')">
                    {{ $t('labels.refuse') }}
                </hts-form-button>
            </div>
        </hts-card>
    </hts-router-drawer>
</template>

<script lang="ts" setup>
import { $downloadjs } from '#imports'

const props = defineProps({
  color: {
    type: String,
    default: 'theme'
  }
})

const buttonApprove = ref(true)

const documentId = computed(() => useRoute().params.iddocumentpartner)
const cooperatorId = computed(() => useRoute().params.idpartner)

const downloadContract = () => {
  const api = {
    url: '/partner/document/cooperatorId/download-contract/ID',
    method: 'get'
  }
  $api(api, { uriParams: { ID: documentId.value, cooperatorId: cooperatorId.value }, contentType: 'blob' }).then((data: any) => {
    const resData: any = data.data.value
    const fileName = resData.headers.get('filename') || 'Contract.docx'
    const contentType = resData.headers.get('Content-type')
    $downloadjs(resData, fileName, contentType)
  })
}

const approveContract = (action: string) => {
  const api = {
    url: '/partner/document/approve-contract/ID',
    method: 'post'
  }
  $api(api, { uriParams: { ID: documentId.value }, body: { action } }).then((data: any) => {
    const resData: any = data.data.value
    if (resData.success) {
      if (action === 'approve') {
        process.client && $toast().success($t('labels.approveSuccess'))
      } else {
        process.client && $toast().success($t('labels.refuseSuccess'))
      }
    }
    buttonApprove.value = false
  })
}
</script>
